import { render, staticRenderFns } from "./PageToolbar.vue?vue&type=template&id=5189cdf0&scoped=true"
import script from "./PageToolbar.vue?vue&type=script&lang=ts"
export * from "./PageToolbar.vue?vue&type=script&lang=ts"
import style0 from "./PageToolbar.vue?vue&type=style&index=0&id=5189cdf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5189cdf0",
  null
  
)

export default component.exports